import type {GridDirection} from '@yandex-delivery/blocks'
import {DeliveryIntervals} from '@yandex-delivery/form'
import React from 'react'

import type {DueSettings} from 'src/shared/types'

import {i18n} from '../../../shared/config'
import {useOrderTime} from './hooks'

type Props = {
  name: string
  dueSettings: DueSettings
  isLoading?: boolean
  direction?: GridDirection
}

export function OrderTime(props: Props): React.ReactElement<Props> {
  const {direction, name, dueSettings, isLoading = false} = props
  const {deliveryDate, dateList, intervalList} = useOrderTime(name, dueSettings)

  return (
    <DeliveryIntervals
      dates={dateList}
      direction={direction}
      intervals={intervalList}
      isLoading={isLoading}
      name={name}
      placeholders={{
        date: i18n('cargo.create.due.select-date', 'Выберите дату'),
        interval: i18n('ndd.delivery-policy.input.time.placeholder', 'Выберите интервал'),
      }}
      selectedDate={deliveryDate}
    />
  )
}
